'use client';

import { AnchorButton } from './AnchorButton.styles';
import { ExpressiveAnchorButtonProps } from '@exploration/shared-components';
import { useRouter } from 'next/navigation';

type Props = {
  advisorSearchText?: string;
} & Omit<ExpressiveAnchorButtonProps, 'href'>;

export const AdvisorButton = ({ advisorSearchText, ...rest }: Props) => {
  const router = useRouter();

  const goToAdvisorPage = (url = '') => {
    let value = '';
    if (advisorSearchText) {
      value = `?qp=${advisorSearchText}`;
    }
    router.push(`${url}${value}`);
  };

  return (
    <AnchorButton
      {...rest}
      href={'https://local.thrivent.com/'}
      onClick={() => goToAdvisorPage('https://local.thrivent.com/')}
    />
  );
};
